export const common = {
  // Navigation
  'nav.features': 'الميزات',
  'nav.howItWorks': 'كيف يعمل',
  'nav.pricing': 'الأسعار',
  'nav.faq': 'الأسئلة الشائعة',
  'nav.aboutUs': 'من نحن',
  'nav.getStarted': 'ابدأ الآن',

  // About Us Section
  'aboutUs.badge': 'من نحن',
  'aboutUs.title': 'من نحن',
  'aboutUs.line1': 'الأفكار رخيصة.',
  'aboutUs.line2': 'رأس المال ليس كذلك. الوقت أقل من ذلك.',
  'aboutUs.paragraph1': 'تأسست IdeaOracle.ai لأن معظم الأفكار التجارية لا تفشل بسبب نقص الشجاعة – بل بسبب نقص الصدق. الكثير من التأكيد. القليل جداً من الواقع.',
  'aboutUs.belief1a': 'لا نؤمن بالضجة الإعلامية.',
  'aboutUs.belief1b': 'نؤمن بمنطق السوق.',
  'aboutUs.belief2a': 'لا نؤمن بالتحفيز.',
  'aboutUs.belief2b': 'نؤمن بالطلب والمنافسة والتمايز.',
  'aboutUs.mission1': 'مهمتنا ليست جعل الأفكار تبدو جيدة.',
  'aboutUs.mission2': 'مهمتنا هي الكشف عن قابليتها للتطبيق.',
  'aboutUs.analysis': 'تحلل IdeaOracle.ai المجالات التجارية من حيث الميكانيكا الهيكلية للسوق والطلب الواقعي وشدة المنافسة والجدوى. ليس عاطفياً. ليس متفائلاً. بل رصيناً.',
  'aboutUs.failure1': 'معظم الأفكار تفشل.',
  'aboutUs.failure2': 'ليس لأن المؤسسين غير قادرين –',
  'aboutUs.failure3': 'بل لأن لا أحد كان واضحاً بما فيه الكفاية مسبقاً.',
  'aboutUs.clarity': 'نحن موجودون لتقديم هذا الوضوح.',
  'aboutUs.value1': 'غير مريح.',
  'aboutUs.value2': 'مباشر.',
  'aboutUs.value3': 'متسق.',
  'aboutUs.confirm': 'إذا كانت الفكرة ذات جوهر، نؤكدها.',
  'aboutUs.deny': 'إذا لم تكن كذلك، نقول ذلك أيضاً.',
  'aboutUs.noApplause': 'بدون تصفيق.',
  'aboutUs.noSugarcoating': 'بدون تجميل.',
  'aboutUs.noTheater': 'بدون مسرح.',

  // Hero Section
  'hero.badge': 'الذكاء الاصطناعي لاتخاذ القرارات في المجالات التجارية',
  'hero.title1': 'الأفكار رخيصة.',
  'hero.title2': 'القرارات السيئة ليست كذلك.',
  'hero.subtitle': 'ذكاء اصطناعي يقيّم مجالك التجاري',
  'hero.subtitleLine2': 'قبل أن تستثمر.',
  'hero.cta': 'تحقق من الفكرة',
  'hero.ctaSecondary': 'كيف يعمل',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'نقاط لكل طلب',
  'hero.stat2Value': '+7',
  'hero.stat2Label': 'مستويات التقييم',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'صادق وخاص',

  // Features Section
  'features.title1': 'ميزات قوية',
  'features.title2': 'للشركات',
  'features.title3': 'الحديثة',
  'features.honestVerdict.title': 'حكم صادق، ليس درجة دعائية',
  'features.honestVerdict.description': 'أحكام حاسمة جيد/متوسط/ضعيف مستندة إلى بيانات سوق حقيقية وبحث عن المنافسين. لا توجد تقييمات 9/10 مصممة لإطراء كل فكرة.',
  'features.fullJourney.title': 'من اختبار الفكرة إلى Builder Report',
  'features.fullJourney.description': 'تحقّق في المحادثة، توغّل في تحليل السوق، صدّر Builder Report من 25–75 صفحة مع شخصيات المستخدمين والمالية وخطة الذهاب إلى السوق وعرض المستثمرين.',
  'features.multilingual.title': '21 لغة وبيانات سوق محلية',
  'features.multilingual.description': 'من الشركات المتوسطة في سويسرا إلى مؤسس فردي في ساو باولو — يجيب الذكاء الاصطناعي بلغتك، بمصادر من سوقك.',

  // How It Works
  'howItWorks.title': 'كيف يعمل',
  'howItWorks.subtitle': 'أربع خطوات للوضوح حول مجالك التجاري.',
  'howItWorks.step1Title': 'اختر خطة',
  'howItWorks.step1Desc': 'Starter أو Pro أو Builder - حسب عمق مراجعتك.',
  'howItWorks.step2Title': 'اسأل الذكاء الاصطناعي',
  'howItWorks.step2Desc': 'اطرح أسئلتك حول المجال. كل طلب يكلف 30 نقطة.',
  'howItWorks.step3Title': 'احصل على حكم صادق',
  'howItWorks.step3Desc': 'يقيّم الذكاء الاصطناعي: جيد، متوسط أو سيئ. بدون تجميل.',
  'howItWorks.step4Title': 'اتخذ قرارًا',
  'howItWorks.step4Desc': 'الآن تعرف ما إذا كان يستحق المضي قدمًا.',

  // Pricing
  'pricing.title': 'الأسعار',
  'pricing.subtitle': 'اختر الخطة التي تناسب عمق مراجعتك.',
  'pricing.yearlyDiscount': 'اشتراك سنوي:',
  'pricing.yearlyDiscountValue': 'خصم -20%',
  'pricing.perMonth': 'شهريًا',
  'pricing.selectPlan': 'اختر الخطة',
  'pricing.mostPopular': 'الأكثر شعبية',
  'pricing.footer': 'جميع الأسعار بالفرنك السويسري. يتم خصم النقاط فقط للردود الناجحة من الذكاء الاصطناعي.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'لاختبارات الواقع الأولية.',
  'pricing.starter.credits': '2,500 نقطة',
  'pricing.starter.feature1': 'توليد فكرة مجال',
  'pricing.starter.feature2': 'تحسين المجال',
  'pricing.starter.feature3': 'فحص واقع السوق',
  'pricing.starter.feature4': 'تقييم المنافسة',
  'pricing.starter.feature5': 'تقييم التوقيت',
  'pricing.starter.feature6': 'حكم صادق',
  'pricing.starter.feature7': 'جلسات خاصة',
  'pricing.starter.feature8': 'السجل والتصدير',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'لمراجعة أعمق.',
  'pricing.pro.credits': '5,000 نقطة',
  'pricing.pro.feature1': 'جميع ميزات Starter',
  'pricing.pro.feature2': 'المزيد من النقاط للمراجعة المكثفة',
  'pricing.pro.feature3': 'اقتراحات التحسين',
  'pricing.pro.feature4': 'مجالات بديلة',
  'pricing.pro.feature5': 'تحليل سوق مفصل',
  'pricing.pro.feature6': 'دعم ذو أولوية',
  'pricing.pro.feature7': 'مرشحات متقدمة',
  'pricing.pro.feature8': 'مفضلات الجلسة',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'فكرة ← موجز للمطورين.',
  'pricing.builder.credits': 'نقاط غير محدودة',
  'pricing.builder.feature1': 'جميع ميزات Pro',
  'pricing.builder.feature2': 'طلبات ذكاء اصطناعي غير محدودة',
  'pricing.builder.feature3': 'وضع Builder: موجز للمطورين',
  'pricing.builder.feature4': 'نظرة عامة منظمة للمشروع',
  'pricing.builder.feature5': 'تدفقات المستخدم والوظائف الأساسية',
  'pricing.builder.feature6': 'ملاحظات تقنية',
  'pricing.builder.feature7': 'تحديد الأهداف غير المرغوبة',
  'pricing.builder.feature8': 'حد معدل الاستخدام العادل',
  'pricing.builder.limitNote': 'حد الاستخدام العادل',
  'pricing.monthlyReset': 'إعادة تعيين شهرية',

  // Modal
  'pricing.modal.selected': 'محدد',
  'pricing.modal.comingSoon': 'سيكون التسجيل ومعالجة الدفع متاحين قريبًا.',
  'pricing.modal.patience': 'نحن نعمل على تزويدك بتجربة آمنة وسلسة. يرجى التحلي بالصبر.',
  'pricing.modal.understood': 'مفهوم',

  // FAQ
  'faq.title': 'الأسئلة الشائعة',
  'faq.subtitle': 'أجوبة صادقة ونقدية.',
  'faq.q1': 'ماذا يفعل IdeaOracle.ai بالتحديد؟',
  'faq.a1': 'يقيّم IdeaOracle.ai الأفكار التجارية والمجالات من حيث منطق السوق والطلب الحقيقي والمنافسة والتمايز والجدوى.\nإذا كان هناك جوهر، نوضح كيف يمكن صقله استراتيجياً.\nإذا لم يكن، نقول ذلك.',
  'faq.q2': 'هل تولّدون أفكاراً أيضاً؟',
  'faq.a2': 'نعم.\nلكن ليس بشكل أعمى.\nنطور مقاربات قائمة على منطق السوق – وليس على الحماس أو ضجة الاتجاهات.',
  'faq.q3': 'هل تحسّنون نماذج الأعمال؟',
  'faq.a3': 'نعم – إذا كان هناك إمكانات.\nلا نصقل الأوهام.\nنجعل المفاهيم القابلة للتطبيق أكثر صلابة.',
  'faq.q4': 'ما الذي يميزكم عن أدوات الذكاء الاصطناعي الأخرى؟',
  'faq.a4': 'الأدوات الأخرى تقدم إلهاماً.\nنحن نقدم تقييماً.\nالتركيز على الواقعية، وليس الحماس.',
  'faq.q5': 'هل هذا ضمان للنجاح؟',
  'faq.a5': 'لا.\nنقلل القرارات الخاطئة – لا نزيل المخاطر.',
  'faq.q6': 'لمن يناسب IdeaOracle.ai؟',
  'faq.a6': 'المؤسسون قبل الإطلاق\nرواد الأعمال قبل التوسع\nالبناة الجانبيون قبل استثمار الوقت\nالمستثمرون قبل الفحص\n\nباختصار: للأشخاص الذين يريدون الوضوح قبل رأس المال.',
  'faq.q7': 'ماذا لو كنت أبحث فقط عن تأكيد؟',
  'faq.a7': 'إذاً IdeaOracle.ai ليس الأداة المناسبة.',
  'faq.q8': 'ما مدى صدق التحليل؟',
  'faq.a8': 'صادق بقدر ما تسمح به البيانات وميكانيكا السوق.\nلا نشوة. لا رحمة.',
  'faq.q9': 'هل تحلّون محل أبحاث السوق؟',
  'faq.a9': 'لا.\nنحن تقييم استراتيجي مسبق – وليس دراسة سوق كاملة.',
  'faq.q10': 'لماذا بلا تنازلات؟',
  'faq.a10': 'لأن الفشل مكلف.\nالصدق ليس كذلك.',

  // Footer
  'footer.description': 'هذه المنصة لا تساعدك على الشعور بالرضا - بل على اتخاذ القرار الصحيح.',
  'footer.product': 'المنتج',
  'footer.aiAssistant': 'مساعد الذكاء الاصطناعي',
  'footer.howItWorks': 'كيف يعمل',
  'footer.pricing': 'الأسعار',
  'footer.faq': 'الأسئلة الشائعة',
  'footer.legal': 'قانوني',
  'footer.privacy': 'الخصوصية',
  'footer.terms': 'الشروط',
  'footer.imprint': 'بيانات النشر',
  'footer.support': 'الدعم',
  'footer.contact': 'اتصل',
  'footer.documentation': 'التوثيق',
  'footer.copyright': '© 2025 IdeaOracle.ai. جميع الحقوق محفوظة.',

  // AI Assistant
  'aiAssistant.title': 'مساعد الذكاء الاصطناعي للمجالات',
  'aiAssistant.subtitle': 'أسئلة حول المجالات',
  'aiAssistant.welcomeMessage': 'مرحبًا! صف فكرتك أو اسألني عن مجال. سأعطيك تقييمًا واضحًا وصادقًا.',
  'aiAssistant.demoResponse': 'هذا عرض توضيحي. للحصول على تقييمات حقيقية من الذكاء الاصطناعي، يرجى التسجيل واختيار خطة.',
  'aiAssistant.placeholder': 'صف فكرتك...',

  // Header & Sidebar
  'dashboard.header.title': 'لوحة التحكم',
  'dashboard.sidebar.overview': 'نظرة عامة',
  'dashboard.sidebar.newAnalysis': 'مساعد الذكاء الاصطناعي',
  'dashboard.sidebar.history': 'السجل',
  'dashboard.sidebar.credits': 'النقاط',
  'dashboard.sidebar.settings': 'الإعدادات',

  // Dashboard Overview
  'dashboard.overview.welcome': 'مرحبًا بعودتك، {{name}}',
  'dashboard.overview.subtitle': 'إليك نظرة سريعة على نشاطك',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'النقاط المتبقية',
  'dashboard.stats.totalAnalyses': 'إجمالي التحليلات',
  'dashboard.stats.goodRatings': 'التقييمات الإيجابية',
  'dashboard.stats.nextReset': 'إعادة التعيين التالية في',
  'dashboard.stats.days': 'أيام',

  // Quick Actions
  'dashboard.quickActions.title': 'إجراءات سريعة',
  'dashboard.quickActions.checkNewIdea': 'تحقق من فكرة',
  'dashboard.quickActions.checkNewIdeaDesc': 'تحليل فكرة تجارية موجودة',
  'dashboard.quickActions.generateIdea': 'توليد فكرة',
  'dashboard.quickActions.generateIdeaDesc': 'العثور على مجال مربح جديد',
  'dashboard.quickActions.builderBriefing': 'موجز Builder',
  'dashboard.quickActions.builderBriefingDesc': 'تحويل فكرة إلى موجز جاهز للمطورين',
  'dashboard.quickActions.premiumOnly': 'Builder فقط',

  // Chat Header
  'chat.title': 'مساعد الذكاء الاصطناعي للمجالات',
  'chat.subtitle': 'اطرح أسئلة حول المجالات. أقيّم بشكل نقدي وصادق.',
  'chat.creditsLabel': 'النقاط',

  // Chat Welcome
  'chat.welcomeTitle': 'مرحبًا بك في مساعد الذكاء الاصطناعي للمجالات',
  'chat.welcomeDesc': 'صف فكرتك أو اسأل عن مجال. سأقيّم بصدق: جيد، متوسط أو سيئ.',
  'chat.aiWelcome': 'مرحبًا! صف فكرتك أو اسألني عن مجال. سأعطيك تقييمًا واضحًا وصادقًا.',

  // Chat Suggestions
  'chat.suggestion1': 'ابحث لي عن مجال مربح.',
  'chat.suggestion2': 'لدي فكرة - قيّمها بصدق.',
  'chat.suggestion3': 'ما المجالات التي لديها إمكانات الآن؟',
  'chat.suggestion4': 'حسّن هذا المجال واجعله أكثر تحديدًا.',

  // Chat Actions
  'chat.newConversation': 'محادثة جديدة',
  'chat.today': 'اليوم',
  'chat.yesterday': 'أمس',
  'chat.thisWeek': 'هذا الأسبوع',
  'chat.thisMonth': 'هذا الشهر',
  'chat.older': 'أقدم',
  'chat.messages': 'رسائل',
  'chat.renameConversation': 'إعادة تسمية',
  'chat.deleteConversation': 'حذف',
  'chat.cancel': 'إلغاء',
  'chat.rename': 'إعادة تسمية',
  'chat.delete': 'حذف',
  'chat.favorite': 'إضافة إلى المفضلة',
  'chat.unfavorite': 'إزالة من المفضلة',
  'chat.searchSessions': 'بحث في المحادثات...',
  'chat.noResults': 'لم يتم العثور على نتائج',
  'chat.noSessions': 'لا توجد محادثات بعد',
  'chat.enterNewName': 'أدخل اسمًا جديدًا...',
  'chat.deleteConfirmMessage': 'هل أنت متأكد من أنك تريد حذف هذه المحادثة؟ لا يمكن التراجع عن هذا الإجراء.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'اكتب سؤالك… (يكلف 30 نقطة)',
  'chat.send': 'إرسال',
  'chat.voice': 'تحدث',
  'chat.listeningPlaceholder': 'أنا أستمع... تحدث الآن.',
  'chat.stopListening': 'إيقاف التسجيل',
  'chat.recording': 'جارٍ التسجيل...',
  'chat.speechNotSupported': 'التعرف على الكلام غير مدعوم من متصفحك.',
  'chat.microphonePermissionDenied': 'تم رفض الوصول إلى الميكروفون. يرجى السماح بالوصول في إعدادات المتصفح.',
  'chat.errorNotEnoughCredits': 'نقاط غير كافية. يرجى ترقية خطتك أو انتظار إعادة التعيين التالية.',
  'chat.errorAiFailed': 'فشل رد الذكاء الاصطناعي. لم يتم خصم النقاط.',
  'chat.errorRateLimit': 'طلبات كثيرة جدًا. يرجى الانتظار لحظة.',

  // Ratings
  'rating.good': 'جيد',
  'rating.medium': 'متوسط',
  'rating.bad': 'سيئ',

  // Auth Page
  'auth.branding.headline1': 'ليست كل فكرة جيدة.',
  'auth.branding.headline2': 'نخبرك بصراحة.',
  'auth.branding.subtitle': 'ذكاء اصطناعي لاتخاذ القرارات في المجالات التجارية. واضح. نقدي. بدون تجميل.',
  'auth.benefits.privacy.title': '100% خاص',
  'auth.benefits.privacy.desc': 'أفكارك تبقى خاصة وآمنة تمامًا.',
  'auth.benefits.honest.title': 'ذكاء اصطناعي صادق',
  'auth.benefits.honest.desc': 'بدون تجميل – فقط ملاحظات واضحة ونقدية.',
  'auth.benefits.fast.title': 'نتائج سريعة',
  'auth.benefits.fast.desc': 'احصل على وضوح حول مجالك في دقائق.',
  'auth.trust.users': 'مستخدمون نشطون',
  'auth.trust.ideas': 'أفكار تم تحليلها',
  'auth.trust.rating': 'التقييم',
  'auth.login.title': 'تسجيل الدخول',
  'auth.login.headline': 'مرحبًا بعودتك',
  'auth.login.subtitle': 'سجل الدخول لمتابعة رحلتك.',
  'auth.login.forgotPassword': 'نسيت كلمة المرور؟',
  'auth.login.submit': 'تسجيل الدخول',
  'auth.login.noAccount': 'ليس لديك حساب؟',
  'auth.login.signUp': 'سجل',
  'auth.register.title': 'التسجيل',
  'auth.register.headline': 'أنشئ حسابك',
  'auth.register.subtitle': 'ابدأ بتحليل أفكارك التجارية اليوم.',
  'auth.register.submit': 'إنشاء حساب',
  'auth.register.hasAccount': 'لديك حساب بالفعل؟',
  'auth.register.signIn': 'تسجيل الدخول',
  'auth.fields.name': 'الاسم الكامل',
  'auth.fields.email': 'البريد الإلكتروني',
  'auth.fields.password': 'كلمة المرور',
  'auth.fields.confirmPassword': 'تأكيد كلمة المرور',
  'auth.fields.selectPlan': 'اختر خطتك',
  'auth.placeholders.name': 'أدخل اسمك',
  'auth.placeholders.email': 'أدخل بريدك الإلكتروني',
  'auth.placeholders.password': 'أدخل كلمة المرور',
  'auth.placeholders.confirmPassword': 'أكد كلمة المرور',
  'auth.terms.accept': 'أوافق على',
  'auth.terms.terms': 'الشروط والأحكام',
  'auth.privacy.accept': 'أوافق على',
  'auth.privacy.policy': 'سياسة الخصوصية',
  'auth.errors.nameRequired': 'الاسم مطلوب',
  'auth.errors.emailRequired': 'البريد الإلكتروني مطلوب',
  'auth.errors.emailInvalid': 'يرجى إدخال بريد إلكتروني صالح',
  'auth.errors.passwordRequired': 'كلمة المرور مطلوبة',
  'auth.errors.passwordLength': 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
  'auth.errors.passwordMismatch': 'كلمات المرور غير متطابقة',
  'auth.loading': 'يرجى الانتظار...',
  'auth.or': 'أو المتابعة مع',
  'auth.social.google': 'المتابعة مع Google',
  'auth.social.apple': 'المتابعة مع Apple',

  // Dashboard (English fallback values — translators can replace later)
  'dashboard.header.tagline': 'Your AI Assistant',
  'dashboard.header.logout': 'Sign out',
  'dashboard.sidebar.dashboard': 'Dashboard',
  'dashboard.sidebar.subscription': 'Subscription & Billing',
  'dashboard.sidebar.plan': 'Plan',
  'dashboard.unlimited': 'Unlimited',
  'dashboard.upgrade': 'Upgrade',
  'dashboard.close': 'Close',
  'dashboard.backToOverview': 'Back to overview',
  'dashboard.overview.title': 'Overview',
  'dashboard.overview.last24Hours': 'Last 24 hours',
  'dashboard.overview.loadError': 'Failed to load overview',
  'dashboard.overview.plan': 'Plan',
  'dashboard.overview.unlimitedCredits': 'Unlimited credits available',
  'dashboard.overview.creditsAvailable': '{{formatted}} credits available',
  'dashboard.overview.creditsUsageThisMonth': 'Credit usage this month',
  'dashboard.overview.creditsAvailablePct': '{{pct}}% available',
  'dashboard.overview.recentActivity': 'Recent activity',
  'dashboard.overview.noActivity': 'No activity yet',
  'dashboard.overview.latestIdeas': 'Latest ideas',
  'dashboard.overview.noIdeas': 'No ideas analyzed yet',
  'dashboard.overview.stats.analysesToday': 'Analyses today',
  'dashboard.overview.stats.analysesTotal': 'Total analyses',
  'dashboard.overview.stats.successRate': 'Success rate',
  'dashboard.overview.stats.topRatings': 'Top ratings',
  'dashboard.overview.activity.nicheAnalysisComplete': 'Niche analysis completed',
  'dashboard.overview.activity.refund': 'Refund',
  'dashboard.overview.activity.payment': 'Payment',
  'dashboard.overview.time.justNow': 'just now',
  'dashboard.overview.time.minutesAgo': '{{count}} min ago',
  'dashboard.overview.time.hoursAgo': '{{count}} h ago',
  'dashboard.overview.time.daysAgo': '{{count}} days ago',
  'chat.ratingStrong': 'Strong',
  'chat.ratingMixed': 'Mixed',
  'chat.ratingWeak': 'Weak',
  'chat.loadIdeaError': 'Could not load idea',
  'chat.deleteError': 'Delete failed',
  'chat.notEnoughCreditsTitle': 'Not enough credits',
  'chat.currentBalance': 'Your current balance:',
  'chat.ai': 'AI',
  'chat.you': 'You',
  'rating.unknown': 'Unknown',
  'dashboard.credits.title': 'Credit usage',
  'dashboard.credits.subtitle': 'Your current consumption',
  'dashboard.credits.loadError': 'Failed to load credits',
  'dashboard.credits.downgradePending': 'Downgrade is awaiting administrator approval.',
  'dashboard.credits.planUpdated': 'Plan updated successfully!',
  'dashboard.credits.planChangeFailed': 'Plan change failed',
  'dashboard.credits.planSuffix': 'Plan',
  'dashboard.credits.downgradeWaiting': 'Downgrade awaiting approval',
  'dashboard.credits.used': 'Used',
  'dashboard.credits.resetOn': 'Reset on {{date}}',
  'dashboard.credits.recentActivity': 'Recent activity',
  'dashboard.credits.noActivity': 'No activity yet',
  'dashboard.credits.currentPackage': 'Your current package',
  'dashboard.credits.chfPerMonth': 'CHF/month',
  'dashboard.credits.creditsPerMonth': '{{formatted}} credits/month',
  'dashboard.credits.perMonth': 'per month',
  'dashboard.credits.upgradePackage': 'Upgrade package',
  'dashboard.credits.changePlan': 'Change plan',
  'dashboard.credits.current': 'Current',
  'dashboard.credits.premium': 'Premium',
  'dashboard.credits.noPlans': 'No plans available.',
  'dashboard.credits.currentPlan': 'Current plan',
  'dashboard.credits.selected': 'Selected',
  'dashboard.credits.selectPlan': 'Select {{plan}}',
  'dashboard.credits.processing': 'Processing...',
  'dashboard.credits.switchPlan': 'Switch plan',
  'dashboard.credits.tx.deduction': 'Credits used',
  'dashboard.credits.tx.reset': 'Monthly reset',
  'dashboard.credits.tx.bonus': 'Bonus credits',
  'dashboard.credits.tx.refund': 'Refund',
  'dashboard.history.title': 'Idea history',
  'dashboard.history.loadError': 'Failed to load ideas',
  'dashboard.history.analysesCount': '{{count}} analyses',
  'dashboard.history.yourLatest': 'Your latest analyses',
  'dashboard.history.refresh': 'Refresh',
  'dashboard.history.exportAll': 'Export all',
  'dashboard.history.searchPlaceholder': 'Search ideas...',
  'dashboard.history.allRatings': 'All ratings',
  'dashboard.history.emptyTitle': 'No analyses yet',
  'dashboard.history.emptyDesc': 'Start a chat to evaluate your first business idea. Completed analyses will appear here automatically.',
  'dashboard.history.startFirstChat': 'Start your first chat',
  'dashboard.history.noMatchTitle': 'No results',
  'dashboard.history.noMatchDesc': 'No analysis matches your filter. Adjust your search or rating.',
  'dashboard.history.fullAnalysis': 'Full analysis',
  'dashboard.history.download': 'Download',
  'dashboard.history.saveAsJson': 'Save as JSON',
  'dashboard.history.saveAsTxt': 'Save as TXT',
  'dashboard.history.saveAsPdf': 'Save as PDF',
  'dashboard.history.deleteAnalysisTitle': 'Delete analysis?',
  'dashboard.history.actionIrreversible': 'This action cannot be undone.',
  'dashboard.history.deleteSuccess': 'Analysis deleted successfully',
  'dashboard.history.deleteError': 'Delete failed',
  'dashboard.history.jsonSuccess': 'JSON file downloaded successfully',
  'dashboard.history.txtSuccess': 'TXT file downloaded successfully',
  'dashboard.history.pdfSuccess': 'PDF file downloaded successfully',
  'dashboard.history.exportError': 'Export failed',
  'dashboard.history.allExportedAsJson': '{{count}} ideas exported as JSON',
  'dashboard.history.marketAnalysis': 'Market analysis',
  'dashboard.history.swotAnalysis': 'SWOT analysis',
  'dashboard.history.recommendations': 'Recommendations',
  'dashboard.history.actionRecommendations': 'Action recommendations',
  'dashboard.history.export.header': 'IDEA ANALYSIS EXPORT',
  'dashboard.history.export.title': 'Title',
  'dashboard.history.export.rating': 'Rating',
  'dashboard.history.export.date': 'Date',
  'dashboard.history.export.category': 'Category',
  'dashboard.history.export.targetAudience': 'Target audience',
  'dashboard.history.export.metrics': 'Metrics',
  'dashboard.history.export.summary': 'Summary',
  'dashboard.history.export.exportedOn': 'Exported on',
  'dashboard.history.pdf.header': 'Business idea analysis',
  'dashboard.history.metrics.marketSize': 'Market size',
  'dashboard.history.metrics.competition': 'Competition',
  'dashboard.history.metrics.startupCost': 'Startup cost',
  'dashboard.history.metrics.timeToMarket': 'Time to market',
  'dashboard.history.metrics.profitPotential': 'Profit potential',
  'dashboard.history.metrics.scalability': 'Scalability',
  'dashboard.history.swot.strengths': 'Strengths',
  'dashboard.history.swot.weaknesses': 'Weaknesses',
  'dashboard.history.swot.opportunities': 'Opportunities',
  'dashboard.history.swot.threats': 'Threats',
  'dashboard.settings.title': 'Settings',
  'dashboard.settings.subtitle': 'Manage your account and preferences',
  'dashboard.settings.loadError': 'Failed to load settings',
  'dashboard.settings.profileSaved': 'Profile saved successfully',
  'dashboard.settings.preferencesSaved': 'Preferences saved successfully',
  'dashboard.settings.notificationsSaved': 'Notification settings saved',
  'dashboard.settings.saveFailed': 'Save failed',
  'dashboard.settings.saving': 'Saving...',
  'dashboard.settings.saveChanges': 'Save changes',
  'dashboard.settings.deleting': 'Deleting...',
  'dashboard.settings.deleteConfirmKeyword': 'DELETE',
  'dashboard.settings.deleteAccountFailed': 'Account deletion failed',
  'dashboard.settings.dataExportSuccess': 'Data exported successfully',
  'dashboard.settings.tabs.profile': 'Profile',
  'dashboard.settings.tabs.preferences': 'Preferences',
  'dashboard.settings.tabs.notifications': 'Notifications',
  'dashboard.settings.tabs.account': 'Account & Subscription',
  'dashboard.settings.profile.name': 'Name',
  'dashboard.settings.profile.email': 'Email',
  'dashboard.settings.profile.phone': 'Phone',
  'dashboard.settings.profile.avatarNote': 'Profile picture can be configured via update URL',
  'dashboard.settings.preferences.language': 'Language',
  'dashboard.settings.preferences.timezone': 'Time zone',
  'dashboard.settings.preferences.currency': 'Currency',
  'dashboard.settings.notifications.emailTitle': 'Email notifications',
  'dashboard.settings.notifications.pushTitle': 'Push notifications',
  'dashboard.settings.notifications.emailAnalysis.title': 'Analysis complete',
  'dashboard.settings.notifications.emailAnalysis.desc': 'Receive an email when your analysis is ready',
  'dashboard.settings.notifications.emailCredits.title': 'Credit updates',
  'dashboard.settings.notifications.emailCredits.desc': 'Notifications about credits and resets',
  'dashboard.settings.notifications.emailBilling.title': 'Invoices & payments',
  'dashboard.settings.notifications.emailBilling.desc': 'Notifications about invoices and subscription changes',
  'dashboard.settings.notifications.emailNewsletter.title': 'Newsletter',
  'dashboard.settings.notifications.emailNewsletter.desc': 'Tips, updates and new features',
  'dashboard.settings.notifications.pushAnalysis.title': 'Analysis complete',
  'dashboard.settings.notifications.pushAnalysis.desc': 'Browser notification when analysis is complete',
  'dashboard.settings.notifications.pushCredits.title': 'Credit warnings',
  'dashboard.settings.notifications.pushCredits.desc': 'Warning for low credit balance',
  'dashboard.settings.account.currentPlan': 'Current subscription',
  'dashboard.settings.account.plan': 'Plan',
  'dashboard.settings.account.price': 'Price',
  'dashboard.settings.account.moAbbrev': 'mo',
  'dashboard.settings.account.nextBilling': 'Next billing',
  'dashboard.settings.account.manageSubscription': 'Manage subscription & payments',
  'dashboard.settings.privacy.title': 'Data & privacy',
  'dashboard.settings.privacy.exportData': 'Export data',
  'dashboard.settings.privacy.deleteAccount': 'Delete account',
  'dashboard.settings.deleteModal.title': 'Delete account?',
  'dashboard.settings.deleteModal.subtitle': 'All data will be permanently deleted.',
  'dashboard.settings.deleteModal.point1': 'All analyses and data will be deleted',
  'dashboard.settings.deleteModal.point2': 'Active subscription will be cancelled immediately',
  'dashboard.settings.deleteModal.point3': 'No refunds possible',
  'dashboard.settings.deleteModal.typeKeyword': 'Type "{{keyword}}" *',
  'dashboard.subscription.title': 'Subscription & Billing',
  'dashboard.subscription.subtitle': 'Manage your subscription and invoices',
  'dashboard.subscription.loadError': 'Failed to load subscription',
  'dashboard.subscription.cancelKeyword': 'CANCEL',
  'dashboard.subscription.cancelSuccess': 'Your subscription has been cancelled at the end of the billing period.',
  'dashboard.subscription.cancelFailed': 'Cancellation failed',
  'dashboard.subscription.reactivate': 'Reactivate',
  'dashboard.subscription.reactivateSuccess': 'Your subscription was reactivated successfully!',
  'dashboard.subscription.reactivateFailed': 'Reactivation failed',
  'dashboard.subscription.pauseSuccess': 'Your subscription has been paused.',
  'dashboard.subscription.pauseFailed': 'Pause failed',
  'dashboard.subscription.downgradePending': 'Downgrade is awaiting administrator approval.',
  'dashboard.subscription.downgradeRequested': 'Downgrade request submitted.',
  'dashboard.subscription.planChangedTo': 'Plan successfully changed to {{plan}}!',
  'dashboard.subscription.newPlan': 'new plan',
  'dashboard.subscription.planChangeFailed': 'Plan change failed',
  'dashboard.subscription.tabs.overview': 'Overview',
  'dashboard.subscription.tabs.billing': 'Billing address',
  'dashboard.subscription.tabs.history': 'Payment history',
  'dashboard.subscription.status.active': 'active',
  'dashboard.subscription.status.cancelled': 'cancelled',
  'dashboard.subscription.status.paused': 'paused',
  'dashboard.subscription.status.overdue': 'overdue',
  'dashboard.subscription.status.label': 'Status',
  'dashboard.subscription.memberSince': 'Member since {{date}}',
  'dashboard.subscription.chfBase': 'CHF {{amount}} base',
  'dashboard.subscription.monthAbbrev': 'month',
  'dashboard.subscription.creditsPerMonth': 'Credits / month',
  'dashboard.subscription.freeAccount': 'Free account',
  'dashboard.subscription.cancelSubscription': 'Cancel subscription',
  'dashboard.subscription.downloadInvoices': 'Download invoices',
  'dashboard.subscription.invoicesAvailable': '{{count}} invoices available as PDF',
  'dashboard.subscription.accountSettings': 'Account settings',
  'dashboard.subscription.accountSettingsDesc': 'Profile, notifications & more',
  'dashboard.subscription.billing.recipient': 'Billing recipient',
  'dashboard.subscription.billing.addressNote': 'Address changes are currently only available in your profile.',
  'dashboard.subscription.history.title': 'Payment history',
  'dashboard.subscription.history.subtitle': 'Download all invoices as PDF',
  'dashboard.subscription.history.downloadAll': 'Download all',
  'dashboard.subscription.history.eurNote': 'Invoices are always issued in CHF. EUR amounts shown are for reference only.',
  'dashboard.subscription.history.noInvoices': 'No invoices yet',
  'dashboard.subscription.history.col.date': 'Date',
  'dashboard.subscription.history.col.type': 'Type',
  'dashboard.subscription.history.col.net': 'Net',
  'dashboard.subscription.history.col.vat': 'VAT',
  'dashboard.subscription.history.col.total': 'Total',
  'dashboard.subscription.history.col.pdf': 'PDF',
  'dashboard.subscription.history.invoicesCount': '{{count}} invoices',
  'dashboard.subscription.history.totalAmount': 'Total amount',
  'dashboard.subscription.switching': 'Switching...',
  'dashboard.subscription.cancelling': 'Cancelling...',
  'dashboard.subscription.cancelNow': 'Cancel now',
  'dashboard.subscription.eurNotice.prefix': 'Prices are displayed in',
  'dashboard.subscription.eurNotice.currency': 'Euro',
  'dashboard.subscription.eurNotice.suffix': '',
  'dashboard.subscription.eurNotice.rate': 'Rate',
  'dashboard.subscription.eurNotice.currentRate': 'Current rate',
  'dashboard.subscription.eurChangePlanNote': 'Prices shown in EUR ({{note}}). Billing is in CHF.',
  'dashboard.subscription.cancelModal.title': 'Cancel subscription?',
  'dashboard.subscription.cancelModal.subtitle': 'Cancellation takes effect at the end of the billing period.',
  'dashboard.subscription.cancelModal.point1': 'No more credits after expiration',
  'dashboard.subscription.cancelModal.point2': 'Premium features will be removed',
  'dashboard.subscription.cancelModal.pauseTitle': 'Alternative: Pause subscription?',
  'dashboard.subscription.cancelModal.pauseDesc': 'Pause your subscription instead and keep your data.',
  'dashboard.subscription.cancelModal.pauseCta': 'Pause instead',
  'dashboard.subscription.cancelModal.reasonLabel': 'Cancellation reason',
  'dashboard.subscription.cancelModal.selectReason': 'Please select...',
  'dashboard.subscription.cancelModal.reasonTooExpensive': 'Too expensive',
  'dashboard.subscription.cancelModal.reasonNotUsing': 'Not using it enough',
  'dashboard.subscription.cancelModal.reasonMissing': 'Missing features',
  'dashboard.subscription.cancelModal.reasonAlternative': 'Found alternative',
  'dashboard.subscription.cancelModal.reasonOther': 'Other',
  'dashboard.subscription.cancelModal.confirmLabel': 'Confirmation: Type "{{keyword}}" *',
  'dashboard.subscription.invoice.heading': 'INVOICE',
  'dashboard.subscription.invoice.from': 'FROM',
  'dashboard.subscription.invoice.to': 'TO',
  'dashboard.subscription.invoice.vatId': 'VAT ID',
  'dashboard.subscription.invoice.date': 'Invoice date',
  'dashboard.subscription.invoice.number': 'Invoice number',
  'dashboard.subscription.invoice.paymentStatus': 'Payment status',
  'dashboard.subscription.invoice.description': 'DESCRIPTION',
  'dashboard.subscription.invoice.quantity': 'QTY',
  'dashboard.subscription.invoice.price': 'PRICE',
  'dashboard.subscription.invoice.amount': 'AMOUNT',
  'dashboard.subscription.invoice.subscriptionLabel': 'Subscription',
  'dashboard.subscription.invoice.subtotal': 'Subtotal',
  'dashboard.subscription.invoice.total': 'Total amount',
  'dashboard.subscription.invoice.downloaded': 'Invoice {{invoiceNo}} downloaded!',
  'dashboard.subscription.invoice.pdfError': 'Failed to create PDF.',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': 'وصول مجاني لمدة 3 أيام',
  'pricing.trial.credits': '250 رصيد',
  'pricing.trial.free': 'مجاني',
  'pricing.trial.duration': 'بدون رسوم لمدة 3 أيام',
  'pricing.trial.cta': 'ابدأ التجربة المجانية',
  'pricing.trial.feature1': '250 رصيد لاستكشاف الذكاء الاصطناعي',
  'pricing.trial.feature2': 'وصول كامل لمدة 3 أيام',
  'pricing.trial.feature3': 'لا حاجة لبطاقة ائتمان',
  'pricing.trial.feature4': 'إلغاء في أي وقت',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10,000 رصيد + تقرير Builder من 25 صفحة',
  'pricing.gold.credits': '10,000 رصيد',
  'pricing.gold.feature1': '10,000 رصيد',
  'pricing.gold.feature2': 'تقرير Builder من 25 صفحة',
  'pricing.gold.feature3': 'جميع ميزات Starter و Pro',
  'pricing.gold.feature4': 'تحليل السوق والملخص',
  'pricing.gold.feature5': 'الفرص والمخاطر والتوصيات',
  'pricing.gold.feature6': 'تنزيل PDF',
  'pricing.gold.feature7': 'دعم',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15,000 رصيد + تقرير Builder من 100 صفحة',
  'pricing.platinum.credits': '15,000 رصيد',
  'pricing.platinum.feature1': '15,000 رصيد',
  'pricing.platinum.feature2': 'تقرير Builder من 100 صفحة',
  'pricing.platinum.feature3': 'جميع ميزات Gold',
  'pricing.platinum.feature4': 'وضع Builder: إحاطات للمطورين',
  'pricing.platinum.feature5': 'ملخص منظم',
  'pricing.platinum.feature6': 'تحليل متقدم للسوق',
  'pricing.platinum.feature7': 'دعم',

  // Pricing UI
  'pricing.monthly': 'شهري',
  'pricing.yearly': 'سنوي',
  'pricing.savings': 'توفير',
  'pricing.billedYearly': 'فوترة سنوية',

  // Hero trial CTA
  'hero.trialTitle': 'ابدأ تجربتك المجانية',
  'hero.creditsLabel': 'الأرصدة',
  'hero.trialTagline': 'جرّب مساعد الذكاء الاصطناعي مجاناً لمدة 3 أيام',
  'hero.trialCta': 'سجّل واحصل على 250 رصيد',
  'hero.trialNoCard': 'لا حاجة لبطاقة ائتمان. بدون التزام.',

  // Admin
  'admin.dashboard.tabs.plans': 'الخطط',

  // Credit top-up
  'dashboard.credits.topup.button': 'شحن الأرصدة',
  'dashboard.credits.topup.buttonTitle': 'اشترِ المزيد من الأرصدة دون تغيير الخطة',
  'dashboard.credits.topup.title': 'شحن الأرصدة',
  'dashboard.credits.topup.subtitle': 'CHF 0.15 لكل رصيد — لا حاجة لتغيير الخطة',
  'dashboard.credits.topup.quickAmounts': 'اختيار سريع',
  'dashboard.credits.topup.custom': 'مخصص',
  'dashboard.credits.topup.totalLabel': 'الإجمالي',
  'dashboard.credits.topup.creditsLabel': 'الأرصدة',
  'dashboard.credits.topup.confirm': 'اشترِ الآن',
  'footer.disclaimer': 'إخلاء المسؤولية',
  'legal.backToHome': 'العودة إلى الصفحة الرئيسية',
  'legal.lastUpdated': 'آخر تحديث',
  'legal.allRightsReserved': 'جميع الحقوق محفوظة.',
  'legal.authoritativeNotice': 'لا تتوفر بعد نسخة محلية بلغتك. يُعرض أدناه النص الإنجليزي الذي يُعتد به قانونياً.',
  'legal.translationNotice': 'هذه ترجمة للتسهيل فقط. النسخة الإنجليزية هي النسخة الأصلية الملزمة قانونياً.',
};

export default common;
